import axios from "axios";

import { API_URL } from "../utils/Constant";

/**
 * API to handle initalize corrective plan for certain swab, or to end a certain corrective plan
 * @param {"create" | "end"} action "create" | "end"
 * @param {string} location_id location id
 * @param {string} sample_id sample id
 * @param {"contamination" | "vector"} plan_type "contamination" or "vector"
 * @param {Object} data received_date; format "MM/DD/YYYY", analysis, test_dates; format "MM/DD/YYYY", sample_list, event_id (only for 'end' action)
 * @param {AbortSignal} signal AbortSignal
 */
export const envCorrectivePlan = async (action, location_id, sample_id, plan_type, data, signal) => {
  try {
    const payload = {
      action,
      location_id,
      sample_id,
      plan_type,
      ...data,
    };
    const response = await axios.post(`${API_URL}/envcorrectiveplan/`, payload, { signal });

    if (response.data.message.toLowerCase() === "success") {
      return { success: true, ...response.data };
    }
    return { success: false, message: response?.data?.message || "Something went wrong." };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong.", canceled: e.code === "ERR_CANCELED" };
  }
};

/**
 * End corrective plan
 * @param {string} event_id plan id
 * @param {AbortSignal} signal abort signal
 */
export const endEnvCorrectivePlan = async (event_id, signal) => {
  try {
    const response = await axios.post(`${API_URL}/envcorrectiveplan/`, { action: "end", event_id }, { signal });

    if (response.data.message.toLowerCase() === "success") {
      return { success: true, ...response.data };
    }
    return { success: false, message: response?.data?.message || "Something went wrong." };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong.", canceled: e.code === "ERR_CANCELED" };
  }
};

/**
 * API to return history user inputs of vector/sub-point's description
 * @param {string} location_id location id
 * @param {AbortSignal} signal AbortSignal
 */
export const getCorrectiveVectorDesp = async (location_id, signal) => {
  try {
    const params = { location_id };
    const response = await axios.get(`${API_URL}/getcorrectivevectordesp/`, { params, signal });

    if (response.data.message.toLowerCase() === "success") {
      return { success: true, ...response.data };
    }
    return { success: false, message: response?.data?.message || "Something went wrong." };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong.", canceled: e.code === "ERR_CANCELED" };
  }
};

/**
 * API to return report and specs for corrective plan vector/sub-points samples
 * @param {string} location_id location id
 * @param {string} received_date received date; format "YYYY-MM-DD"
 * @param {string} event_id plan id
 * @param {AbortSignal} signal AbortSignal
 */
export const envCorrectiveReportSpecs = async (location_id, received_date, event_id, signal) => {
  try {
    const params = { location_id, received_date };
    const response = await axios.get(`${API_URL}/envcorrectivereportspecs/`, { params, signal });

    if (response.data.message.toLowerCase() === "success") {
      return { success: true, ...response.data };
    }
    return { success: false, message: response?.data?.message || "Something went wrong." };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong.", canceled: e.code === "ERR_CANCELED" };
  }
};

/**
 * Edit/Reschedule api
 * @param {"edit_test" | "edit_sample" | "delete"} action "edit_test", "edit_sample", "delete"
 * @param {string} original_submission_id original submission id
 * @param {string} original_sample_id sample id of original submission
 * @param {string[]} updated_tests list of updated tests - optional
 * @param {string} new_submission_id new submission id - optional
 * @param {Date | string} new_date new reschedule date - optional
 * @param {AbortSignal} signal abort signal
 */
export const envEditCorrectiveSample = async (action, original_submission_id, original_sample_id, updated_tests = [], new_submission_id, new_date, signal) => {
  try {
    const payload = {
      action,
      original_submission_id,
      original_sample_id,
      updated_tests,
      new_submission_id,
      new_date,
    };
    const response = await axios.post(`${API_URL}/editscheduledsample/`, payload, { signal });

    if (response.data.message.toLowerCase() === "success") {
      return { success: true, ...response.data };
    }
    return { success: false, message: response?.data?.message || "Something went wrong." };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong.", canceled: e.code === "ERR_CANCELED" };
  }
};
